/*
Purpose: Configuration functions for different sidebar contexts.
Audience: Developers.
What it does:
- Provides standardized sidebar item configurations for different pages
- Centralizes sidebar logic and makes it easy to maintain
*/
import { 
  FaFolderOpen, 
  FaPlus, 
  FaChartBar, 
  FaClock, 
  FaRobot,
  FaUpload, 
  FaEdit, 
  FaTrashAlt, 
  FaGlobe, 
  FaArrowLeft,
  FaNewspaper,
  FaUsers,
  FaSearch,
  FaStar,
  FaFire,
  FaCoins,
  FaImages
} from 'react-icons/fa';

// Dashboard sidebar configuration
export const getDashboardSidebarItems = (activeTab, onTabChange, openLatestResults) => [
  {
    id: 'your-cases',
    label: 'Your Cases',
    icon: FaFolderOpen,
    description: 'Manage your casefiles',
    onClick: () => onTabChange('your-cases'),
    show: true
  },
  {
    id: 'add-case',
    label: 'Add Case',
    icon: FaPlus,
    description: 'Create new casefile',
    onClick: () => onTabChange('add-case'),
    show: true
  },
  {
    id: 'user-activity',
    label: 'Activity',
    icon: FaChartBar,
    description: 'Stats and activity feed',
    onClick: () => onTabChange('user-activity'),
    show: true
  },
  {
    id: 'recently-viewed',
    label: 'Recently',
    icon: FaClock,
    description: 'Recently viewed cases',
    onClick: () => onTabChange('recently-viewed'),
    show: true
  },
  {
    id: 'results',
    label: 'Results',
    icon: FaRobot,
    description: 'View latest analysis results',
    onClick: openLatestResults,
    show: true
  }
];

// Casefile detail sidebar configuration
export const getCasefileSidebarItems = ({ 
  isOwner, 
  isPublic, 
  onUpload,
  onEdit, 
  onDelete, 
  onPublicToggle, 
  onBack,
  openCaseResults
}) => [
  {
    id: 'back',
    label: 'Back',
    icon: FaArrowLeft,
    description: 'Go back to previous page',
    onClick: onBack,
    show: true,
    color: '#6b7280'
  },
  {
    id: 'upload',
    label: 'Upload Evi...',
    icon: FaUpload,
    description: 'Upload new evidence to this casefile',
    onClick: onUpload,
    show: isOwner,
    color: '#059669'
  },
  {
    id: 'edit',
    label: 'Edit Casefile',
    icon: FaEdit,
    description: 'Edit casefile details and metadata',
    onClick: onEdit,
    show: isOwner,
    color: '#0891b2'
  },
  {
    id: 'public',
    label: 'Make Public',
    icon: FaGlobe,
    description: isPublic ? 'Make this casefile private' : 'Make this casefile public',
    onClick: onPublicToggle,
    show: isOwner,
    isToggle: true,
    isActive: isPublic,
    color: '#7c3aed'
  },
  {
    id: 'delete',
    label: 'Delete Cas...',
    icon: FaTrashAlt,
    description: 'Permanently delete this casefile',
    onClick: onDelete,
    show: isOwner,
    color: '#dc2626'
  },
  {
    id: 'results',
    label: 'Results',
    icon: FaRobot,
    description: 'View analysis results for this casefile',
    onClick: openCaseResults,
    show: true,
    color: '#4f46e5'
  }
];


// Bulletin sidebar configuration
export const getBulletinSidebarItems = (activeTab, onTabChange) => [
  {
    id: 'public-evidence',
    label: 'Public Evidence',
    icon: FaImages,
    description: 'Browse all evidence from public cases',
    onClick: () => onTabChange('public-evidence'),
    show: true
  },
  {
    id: 'public-casefiles',
    label: 'Public Casefiles',
    icon: FaNewspaper,
    description: 'Browse all public casefiles',
    onClick: () => onTabChange('public-casefiles'),
    show: true
  },
  {
    id: 'bulletin-activity',
    label: 'Activity',
    icon: FaChartBar,
    description: 'Community activity and stats',
    onClick: () => onTabChange('bulletin-activity'),
    show: false
  },
  {
    id: 'trending',
    label: 'Trending',
    icon: FaFire,
    description: 'Most popular cases',
    onClick: () => onTabChange('trending'),
    show: false
  },
  {
    id: 'recent-uploads',
    label: 'Recent',
    icon: FaClock,
    description: 'Recently uploaded cases',
    onClick: () => onTabChange('recent-uploads'),
    show: false
  },
  {
    id: 'community',
    label: 'Community',
    icon: FaUsers,
    description: 'Community highlights',
    onClick: () => onTabChange('community'),
    show: true
  },
  {
    id: 'search-advanced',
    label: 'Advanced Search',
    icon: FaSearch,
    description: 'Advanced search and filters',
    onClick: () => onTabChange('search-advanced'),
    show: false
  },
  {
    id: 'featured',
    label: 'Featured',
    icon: FaStar,
    description: 'Featured and highlighted cases',
    onClick: () => onTabChange('featured'),
    show: false
  },
  {
    id: 'global-stats',
    label: 'Global Stats',
    icon: FaGlobe,
    description: 'Platform-wide statistics',
    onClick: () => onTabChange('global-stats'),
    show: true
  },
  {
    id: 'bounties',
    label: 'Bounties',
    icon: FaCoins,
    description: 'Rewards and bounties',
    onClick: () => onTabChange('bounties'),
    show: true
  }
];
